<div class="row pt-2">
  <div class="h-scrollable-wrapper">
    <div class="h-scrollable info-container">
      <table class="mr-md-auto">
        <tr>
          <td class="bold">{{"FINANCIAL.AS_OF_END" | translate}}:</td>
          <td>{{data.asOfEnd !== null ? data.asOfEnd : '-'}}</td>
          <td class="bold">{{"FINANCIAL.PRICE" | translate}}:</td>
          <td>{{data.price !== null ? (data.price | rmsNumberTransform: false: 2: '': data.currencyCode) : '-'}}</td>
          <td class="bold">{{"FINANCIAL.SHARES" | translate}}:</td>
          <td>{{data.shares !== null ? (data.shares | rmsFormatMoney) : '-'}}</td>
          <td class="bold">{{"FINANCIAL.M_CAP" | translate}}:</td>
          <td>{{data.marketCap !== null ? (data.marketCap | rmsFormatMoney: data.currencyCode) : '-'}}</td>
          <td class="bold">{{"FINANCIAL.EV" | translate}}:</td>
          <td>{{data.ev ? (data.ev | rmsFormatMoney: data.currencyCode) : '-'}}</td>
        </tr>
        <tr>
          <td class="bold">{{"FINANCIAL.TARGETS" | translate}}:</td>
          <td>
            <span>{{data.targetLong !== null ? (data.targetLong | rmsFormatMoney: data.currencyCode: 2) : '-'}}</span>
            <span>{{data.targetFair !== null ? (data.targetFair | rmsFormatMoney: data.currencyCode: 2) : '-'}}</span>
            <span>{{data.targetShort !== null ? (data.targetShort | rmsFormatMoney: data.currencyCode: 2) : '-'}}</span>
          </td>
          <td class="bold">{{"FINANCIAL.CASH" | translate}}:</td>
          <td>{{data.cash !== null ? (data.cash | rmsFormatMoney: data.currencyCode) : '-'}}</td>
          <td class="bold">{{"FINANCIAL.BURN" | translate}}:</td>
          <td>
            {{data.burn !== null ? (data.burn | rmsFormatMoney: data.currencyCode) : '-'}}
            ({{data.yearsOfCash !== null ? data.yearsOfCash.toFixed(1) : '-'}} Y)
          </td>
          <td class="bold">{{"FINANCIAL.DEBT" | translate}}:</td>
          <td>{{data.debt !== null ? (data.debt | rmsFormatMoney: data.currencyCode: 1) : '-'}}</td>
          <td class="bold">{{"FINANCIAL.REVENUE" | translate}}:</td>
          <td>{{data.revenue !== null ? (data.revenue | rmsFormatMoney: data.currencyCode: 1) : '-'}}</td>
        </tr>
      </table>
      <rms-text-content-attachments [attachments]="attachments" *ngIf="attachments"></rms-text-content-attachments>
    </div>
  </div>
</div>

